var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hotel-detail" }, [
    _c("a", { attrs: { href: _vm.url, target: "_blank" } }, [
      _c("h3", [_vm._v(_vm._s(_vm.name))])
    ]),
    _vm._v(" "),
    _c("div", [
      _c("div", { staticClass: "address" }, [
        _c("div", { staticClass: "address-line-1" }, [
          _vm._v(_vm._s(_vm.address))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "city" }, [_vm._v(_vm._s(_vm.city))]),
        _vm._v(" "),
        _c("div", { staticClass: "zip" }, [_vm._v(_vm._s(_vm.zip))])
      ]),
      _vm._v(" "),
      _vm.blockLink
        ? _c("p", { staticClass: "block-link" }, [
            _c("a", { attrs: { href: _vm.blockLink, target: "_blank" } }, [
              _vm._v("Special block rates available")
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fbb3d092", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbb3d092","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/hotel-info.vue
// module id = 73
// module chunks = 0